import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@e2n/ui/v2';
import { faMessageLines } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import { useState } from 'react';

export function BemerkungDrawer({ bemerkung }: { bemerkung: string }) {
  const [open, setOpen] = useState(false);

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>
        <Button
          variant="ghost"
          iconOnly
          aria-label={t('actions.bearbeiten')}
          size="small">
          <FontAwesomeIcon icon={faMessageLines} />
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>
            {t('domain.mitarbeiter.feiertagskonto.kontoausgleich.bemerkung')}
          </DrawerTitle>
        </DrawerHeader>
        <DrawerBody> {bemerkung}</DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
